import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import global_ from './global' // archivo de referencia
import Vuelidate from 'vuelidate'
import Notificacion from './plugins/Notificacion'
//
require('./plugins/fontawesome')
require('./plugins/Bootstrap')
require('./layouts')

Vue.use(Vuelidate)
Vue.use(Notificacion)

Vue.config.productionTip = false
Vue.prototype.GLOBAL = global_ // Instalar en instancia de Vue

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
